<template>
  <div class="docuform-content">
    <div class="docuform-content__bar-content-wrap">
      <GeneralTabs
        :tabs="tabs"
        :active-tab="activeTab"
        :slider-color="hoverColor"
        :disable-hover="false"
        :remove-background-color="true"
        @tab-clicked="tabChange"
        class="preview-tabs"
        background-color="white">
        <template slot="pre-tabs">
          <div class="docuform-content__actions-wrap">
            <DocuformActions
              :is-infected="isInfected"
              :item="item"
              :is-mobile="isMobile"
              :contact-uid="currContact.uid"
              :contact-name="currContact.full_name"
              :download-src="downloadSrc"
              :matter-uid="matter.uid"
              :account-can-send-link="account.business.can_send_link" />
          </div>
        </template>
        <template v-if="isMobile" v-slot:tabTitle="{tab, index, activeTab}" >
          <v-icon>
            {{tab.icon}}
          </v-icon>
        </template>
        <v-tab-item v-for="(tab, idx) in tabs"
                    :value="idx"
                    :key="idx">
          <component :is="tab.cmp"
                     :item="item"
                     :account-can-send-link="account.business.can_send_link"
                     :preview_src="previewSrc" />
        </v-tab-item>
      </GeneralTabs>
    </div>

  </div>
</template>

<script>
import { DocuformPreview, DocuformDetails, DocuformActions } from "./index";
import { appsService } from "@/modules/appMarket/services/appsService";
import { GeneralTabs } from "@/modules/common/components";
import { tabs } from "../constants";
import { mapGetters } from "vuex";

export default {
  name: "DocuformContent",
  components: { GeneralTabs, DocuformPreview, DocuformDetails, DocuformActions },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: 0,
      previewSrc: '',
      downloadSrc: '',
    };
  },
  async created() {
    this.tabs = tabs;
    this.init();
  },
  computed: {
    ...mapGetters(['isMobile', 'isMobileApp', 'lang']),
    ...mapGetters('mattersModule', ['matter', 'currContact']),
    ...mapGetters('brandModule', ['primaryColor', 'tabsColor', 'hoverColor']),
    ...mapGetters("accountModule", ["account"]),
    isInfected() {
      return this.item?.metadata?.infected === "true"
    },
    staffUid(){
      return this.account.staff.uid
    },
    businessUid(){
      return this.account.business.uid
    },
  },
  methods: {
    async init() {
      const businessApps = await appsService.getExternalApps();
      const businessApp = businessApps.apps.find(app => app.app_code_name === this.item.app_code_name);
      const appUri = businessApp?.api_uri;
      if (!businessApp || !appUri) return;
      this.previewSrc = `${appUri}/app/#/preview/${this.item.uid}?business_uid=${this.businessUid}&staff_id=${this.staffUid}&matter_uid=${this.item.matter_uid}&lang=${this.lang}&mobile=${this.isMobile}&mobile_app=${this.isMobileApp}`;
      this.downloadSrc = `${appUri}/download/${this.item.uid}?business_uid=${this.businessUid}&staff_uid=${this.staffUid}&matter_uid=${this.item.matter_uid}`;
    },
    tabChange(newTab) {
      this.activeTab = tabs.findIndex((tab) => tab.id === newTab.id);
      this.$track('Document activity page action', {
        action: newTab.id + '_tab'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.docuform-content {
  display: flex;
  flex-direction: column;
  width: inherit;
  max-width: inherit;
  overflow: hidden;
  height: calc(100vh - var(--card-height));

  ::v-deep .v-item-group.v-tabs-bar {
    max-height: 48px;
  }

  ::v-deep .v-slide-group__wrapper {
    padding-inline-end: 12px;
    max-width: 100vw;
    width: 100vw;
    overflow: hidden;

    @include md-and-up-main {
      padding-inline-end: 24px;
    }
  }

  &__actions-wrap {
    flex-grow: 1;
    margin: 0;

    @include sm-and-down-main {
      padding-inline-start: 24px;
    }

  }

  &__bar-content-wrap {
    height: calc(100vh - var(--card-height));
  }

  ::v-deep .general-tabs {
    .v-slide-group__wrapper {
      box-shadow: 0px 3px 2px 0px rgb(0 0 0 / 10%);
      z-index: 10;
    }

    span.tab-title {
      text-transform: capitalize;
      font-size: 13px;
      letter-spacing: -0.03em;
    }

    .v-tab {
      @include sm-and-down-main {
        min-width: auto;
        width: 44px;
      }
    }

    .v-window .v-window__container .v-window-item {
      overflow-y: hidden;
    }
  }
}

</style>
